import { ClassType } from "src/modules/utils/shared/class-type";
import { Strings } from "src/modules/utils/shared/strings";
import { RestEndpoint } from "./rest-endpoint.model";
import { AdminPageDefinition } from "./admin-page-definition.model";
import { MainAppService } from "src/modules/app-template/services/main-app.service";
import { ComponentView } from "src/modules/app-template/models/component-view.model";

export class EntityDefinition<T> {
    type: ClassType<T>;
    name = "";
    namePlural = "";
    category = "";
    icon = "";
    apiEndpoint = "";
    adminListUrl: string = null;
    adminEditUrl: string = null;
    canDelete = true;
    canInsert = true;

    getAdminPage(): AdminPageDefinition {
        return new AdminPageDefinition(this.namePlural, this.category, this.icon, [this.adminListUrl]);           
    }

    getAdminEditUrl(): string {
        return this.adminEditUrl != null ? this.adminEditUrl : this.adminListUrl != null ? Strings.removeSuffix(this.adminListUrl, "s") : null;
    }

    async restGet(id: number): Promise<T> {
        return await RestEndpoint.main().query({id}).run(this.apiEndpoint).get(this.type as ClassType<object>) as T;
    }

    async restDelete(id: number): Promise<void> {
        await RestEndpoint.main().delete().query({id}).run(this.apiEndpoint).getText();
    }

    async restList(): Promise<T[]> {
        return await RestEndpoint.main().run(this.apiEndpoint).list(this.type as ClassType<object>) as T[];
    }

    async loadDataHandlerGet(id: number, app: MainAppService, source: ComponentView): Promise<T> {
        return app.loadDataHandler(async () => this.restGet(id), source);
    }

    async loadDataHandlerList(app: MainAppService, source: ComponentView): Promise<T[]> {
        return app.loadDataHandler(async () => this.restList(), source);
    }

    async deleteDataHandler(id: number, app: MainAppService, source: ComponentView): Promise<[boolean, any]> {
        return app.deleteDataHandler(async () => this.restDelete(id), source, true);
    }
}